module.exports = __webpack_public_path__ + "static/media/campfire.9c00f6aa.svg";